module.exports = __webpack_public_path__ + "img/td-icon6.c177a4a8.png";